// ARKA — botão de tema claro/escuro + hook do tema atual (FONTE CANÔNICA: design/arka/).
import React, { useEffect, useState } from 'react';
import { getArkaMode, setArkaMode } from './tokens';

// Tema atual, reativo: observa o data-theme do <html>.
export function useArkaMode() {
  const [mode, setMode] = useState(getArkaMode);
  useEffect(() => {
    const obs = new MutationObserver(() => setMode(getArkaMode()));
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] });
    return () => obs.disconnect();
  }, []);
  return mode;
}

export default function ThemeToggle() {
  const mode = useArkaMode();
  const next = mode === 'dark' ? 'light' : 'dark';
  const label = next === 'light' ? 'Mudar para o tema claro' : 'Mudar para o tema escuro';
  return (
    <button type="button" className="arka-icon-btn" onClick={() => setArkaMode(next)} title={label} aria-label={label}>
      {mode === 'dark' ? (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" aria-hidden="true">
          <path d="M12 3v2m0 14v2m9-9h-2M5 12H3m14.5-6.5-1.4 1.4M7.9 16.1l-1.4 1.4m11.6 0-1.4-1.4M7.9 7.9 6.5 6.5" />
          <circle cx="12" cy="12" r="4" />
        </svg>
      ) : (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5Z" />
        </svg>
      )}
    </button>
  );
}
